/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adjustPermit} from '../api'

export const useMutationAdjustPermit = createReactQueryMutationHook('adjustPermit', adjustPermit)
